<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>bookmark</mat-icon>
      Cohorts
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    <table mat-table [dataSource]="DataSource.Cohorts">
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let row">{{row.title}}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions">&nbsp;</th>
        <td mat-cell *matCellDef="let row" class="actions">
          <button mat-icon-button (click)="setCohorts(row)">
            <mat-icon
              >{{ row.checked && 'check_box' || 'check_box_outline_blank'
              }}</mat-icon
              >
              @if (cohortLoading === row.id) {
                <mat-spinner
                  diameter="20"
                ></mat-spinner>
              }
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </section>
  </section>
